/**
 * Konstanta Bidang / Kategori Perlombaan Sekolah
 * Menyelaraskan kategori kompetisi resmi (OSN, OPSI, O2SN, FLS2N, LDBI, FIKSI, MTQ, dll.)
 * Digunakan bersama di Backoffice CMS (pena-master-mf, pena-edu-sms-mf) dan Portal Siswa (pena-portal-edu-mf).
 */
export const BIDANG_LOMBA_OPTIONS = [
    { value: "Sains & Matematika", label: "Sains & Matematika" },
    { value: "Riset & Karya Ilmiah", label: "Riset & Karya Ilmiah (KIR)" },
    { value: "Teknologi & Robotika", label: "Teknologi & Robotika" },
    { value: "Sosial & Humaniora", label: "Sosial, Bisnis & Humaniora" },
    { value: "Bahasa & Debat", label: "Bahasa & Debat" },
    { value: "Seni & Desain", label: "Seni, Desain & Sastra" },
    { value: "Olahraga & Atletik", label: "Olahraga & Atletik" },
    { value: "Keagamaan", label: "Keagamaan" },
    { value: "Kepramukaan & PMR", label: "Kepramukaan & Palang Merah" },
    { value: "Lainnya", label: "Lainnya / Umum" },
];
